import ModalPortal from '@/components/ModalPortal/ModalPortal';
import type { UseFormState } from '@/hooks/useForm/interfaces';
import useFrcCaptcha from '@/hooks/useFrcCaptcha/useFrcCaptcha';
import useSubmitContactForm from '@/hooks/useSubmitContactForm/useSubmitContactForm';
import CourseContactForm from '@/uikit/components/CourseContactForm/CourseContactForm';
import ModalContent from '@/uikit/components/Modal/ModalContent';
import { createCourseContactSubmitFormData } from './helpers';
import { CourseContactFormModalProps } from './types';

const FORM_NAME = 'Allgemeine Anfrage Schulungscenter';

const CourseContactFormModal = ({
  categoryTitle,
  courseTitle,
  formApiTarget,
  id,
  link,
  mailTemplateId,
  recipientId,
}: CourseContactFormModalProps) => {
  const { getSolution, FrcCaptchaComponent } = useFrcCaptcha();

  const { submitContactForm, submitButtonStatus: contactFormStatus } =
    useSubmitContactForm({
      formName: FORM_NAME,
      recipientId,
      mailTemplateId,
      formApiTarget,
      doubleOptInActive: false,
      getCaptchaSolution: getSolution,
    });

  const handleSubmitContactForm = (formState: UseFormState) => {
    const data = createCourseContactSubmitFormData({
      ...formState,
      categoryTitle,
      courseTitle,
      link,
    });

    submitContactForm(data);
  };

  return (
    <ModalPortal id={id}>
      <ModalContent>
        <CourseContactForm
          onSubmit={handleSubmitContactForm}
          submitButtonStatus={contactFormStatus}
          formName={FORM_NAME}
        />
        <FrcCaptchaComponent />
      </ModalContent>
    </ModalPortal>
  );
};

export default CourseContactFormModal;
